import Message from 'owa-service/lib/contract/Message';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function (message: Message): boolean {
    if (!isConsumer() && !isFeatureEnabled('rp-reactions')) {
        return message.LikeCount ? message.LikeCount > 0 : false;
    }

    return false;
}
